import React, { useEffect, useState } from "react";
import "./ChatBot.scss";
import louie_2 from "../../../images/louie_2.png";
import ttec_small_logo from "../../../images/ttec_small_logo.jpg";
declare global {
  namespace JSX {
    interface IntrinsicElements {
      "df-messenger": any;
      "df-messenger-chat-bubble": any;
    }
  }
}
export function ChatBot() {
  const [oracleIdChatBot, setOracleIdChatBot] = useState("0");

  useEffect(() => {
    let id: any = localStorage.getItem("oracleId");
    setOracleIdChatBot(id);

    // Set image attributes dynamically after mount
    setTimeout(() => {
      const chatBubble = document.querySelector("df-messenger-chat-bubble");
      if (chatBubble) {
        chatBubble.setAttribute("chat-icon", louie_2);
        chatBubble.setAttribute("chat-title-icon", ttec_small_logo);
      }
    }, 500);
  }, []);

  let queryParameters =
    `{ parameters: { oracleid: "'` + oracleIdChatBot + `'" } }`;

  /* let parametersObj = `{ parameters: { oracleid: "'oracleid'" } }`; */

  return (
    <>
      {/* <script src="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js"></script> */}

      <df-messenger
        project-id="chatbot-prod-379e"
        agent-id="22f0a368-d1b0-458e-909e-c192ef86e0d5"
        language-code="en"
        url-allowlist="*"
        allow-feedback="all"
        intent="ELCStart"
      >
        <df-messenger-chat-bubble chat-title="ELC ChatBot" />
      </df-messenger>
      <div
        id="ttec-page-info"
        data-ttec-env-type="dev"
        style={{ display: "none" }}
      >
        {oracleIdChatBot}
      </div>
      <script>
        const dfMessenger = document.querySelector('df-messenger'); var
        ttecpageinfo = document.getElementById('ttec-page-info'); var
        employeeidvalue = ttecpageinfo.innerHTML; var oracleid =
        employeeidvalue.trim();
        {/* const queryParameters = JSON.parse('{"parameters": {"oracleid":"'+oracleid+'"}}'); */}
        const queryParameters = JSON.parse({queryParameters});
        dfMessenger.setQueryParameters(queryParameters);
      </script>
    </>
  );
}
